import { formatMessage } from 'src/i18n/intl';
import { getNumberOfAssignedPermissions } from 'src/features/application-roles/components/GranularPremission/utils';
import Locale from 'src/i18n';

export const ASIO_CONNECTED_APP_CLIENT_ID = 'asio_platform';
export const CUSTOM_ROLE_TYPE = 'custom';
export const DEFAULT_ROLE_TYPE = 'default';

export const CLONE_APP_ROLE_DRAWER = 'CLONE_APP_ROLE_DRAWER';

export const EDIT_APP_ROLE_DRAWER = 'EDIT_APP_ROLE_DRAWER';
export const EDIT_APP_ROLE_FINAL_STEP = 1;

export const CLOSE_WARNING_DIALOG = 'CLOSE_WARNING_DIALOG';
export const DELETE_CUSTOM_ROLE_DIALOG = 'DELETE_CUSTOM_ROLE_DIALOG';
export const DUPLICATE_APP_ROLES_DIALOG = 'DUPLICATE_APP_ROLES_DIALOG';

export const ROLE_INFORMATION_TAB_KEY = 'roleInformation';
export const ROLE_PERMISSIONS_TAB_KEY = 'rolePermissions';
export const ROLE_CONTENTS_TAB_KEY = 'roleContents';

export const optInStatus = {
    IN_PROGRESS: 'in_progress',
    OPTED: 'opted',
    NOT_OPTED: 'not_opted',
};

export const optInProcessUniversityDocumentLink =
    'https://docs.connectwise.com/ConnectWise/Asio/Access_Rights_and_User_Roles/Custom_Application_Roles#How_to_enable_customized_roles_for_your_Asio_Platform';

export const optInProcessFAQLink =
    'https://docs.connectwise.com/ConnectWise/Asio/Access_Rights_and_User_Roles/Custom_Application_Roles/Custom_Application_Roles_FAQs';

export const CLONE = 'clone';
export const EDIT = 'edit';

export const DOMAINS_SEARCH_FIELD = 'displayName';

export const DOMAINS_PATH = ['domains'];
export const APP_ROLES_SEARCH_PATH = ['appRolesSearchText'];

export const ADMIN_TAG = 'admin_tag';
export const DEFAULT_TAG = 'default_tag';
export const CUSTOM_TAG = 'custom_tag';

export const SORT_ALPHABETICAL_ASCENDING = 'sortAlphabeticalAscending';
export const SORT_ALPHABETICAL_DESCENDING = 'sortAlphabeticalDescending';
export const SORT_NUMBER_OF_PERMISSIONS_ASCENDING = 'sortNumberOfPermissionsAscending';
export const SORT_NUMBER_OF_PERMISSIONS_DESCENDING = 'sortNumberOfPermissionsDescending';

export const SORTING_OPTION_MENU_DOMAINS = {
    [SORT_ALPHABETICAL_ASCENDING]: {
        value: SORT_ALPHABETICAL_ASCENDING,
        label: formatMessage(Locale.sortDomainsAlphabeticalAscending),
        SortComparatorFunc: (a, b) => a.displayName.localeCompare(b.displayName),
    },
    [SORT_ALPHABETICAL_DESCENDING]: {
        value: SORT_ALPHABETICAL_DESCENDING,
        label: formatMessage(Locale.sortDomainsAlphabeticalDescending),
        SortComparatorFunc: (a, b) => b.displayName.localeCompare(a.displayName),
    },
    [SORT_NUMBER_OF_PERMISSIONS_ASCENDING]: {
        value: SORT_NUMBER_OF_PERMISSIONS_ASCENDING,
        label: formatMessage(Locale.sortDomainsNumberOfPermissionsAssignedAscending),
        SortComparatorFunc: (a, b) => getNumberOfAssignedPermissions(a) - getNumberOfAssignedPermissions(b),
    },
    [SORT_NUMBER_OF_PERMISSIONS_DESCENDING]: {
        value: SORT_NUMBER_OF_PERMISSIONS_DESCENDING,
        label: formatMessage(Locale.sortDomainsNumberOfPermissionsAssignedDescending),
        SortComparatorFunc: (a, b) => getNumberOfAssignedPermissions(b) - getNumberOfAssignedPermissions(a),
    },
};

export const AUTO_SELECTED_PERMISSIONS_PATH = ['autoSelectedPermissions'];

export const USER_MGMT_IS_MENU_OPENED = 'cw:um_app_roles_sidebar_opened';
